export let links = {
  Basket: "/basket",
  UserAddresses: "/profile/addresses",
  UserTransactions: "/profile/transactions",
  Personalization: "/profile/personalization",
  EditProfile: "/profile/edit",
  NewAddress: "/profile/addresses/add",
  AppInfo: "/profile/info",
  OrderView: "/orders",

  // These should be last items
  Home: "/",
  Profile: "/profile",
  Orders: "/orders",
  Services: "/services",
};
